import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//

import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import ButtonMain from "../../../../../../common/components/button/ButtonMain";
import { StoreContext } from "../../../../../../store/StoreProvider";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import urls from "../../../../../../api/project/ApiUrls";
import useModulePublic from "../../../../../hooks/useModulePublic";
import fireAuth from "../../../../../../api/firebase/auth/utils";
import Act from "../../../../../../store/actions";
//

const BottomPanel = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { dataset } = sna;
  // local state
  const [test, setTest] = useState(0);
  const [datasetSelect, setDatasetSelect] = useState([]);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  const handleDisabled = (moduleId) => !handlePublic(moduleId);
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  useEffect(() => {
    // 整理dataset中的 public, group, private中有 checked 的資料到 datasetSelect 中
    const newDatasetSelect = Object.entries(dataset).reduce(
      (acc, [key, list]) => {
        (list || []).forEach((file) => {
          if (file.checked) {
            acc.push({
              ...file,
              datasetType: key, // group, public, personal
            });
          }
        });
        return acc;
      },
      []
    );
    setDatasetSelect(newDatasetSelect);
  }, [dataset]);

  const disabledSubmitBtn = !(
    Array.isArray(datasetSelect) && datasetSelect.length > 0
  );

  const getSubmitBtnSx = () => {
    if (disabledSubmitBtn) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const handleSubmit = () => {
    dispatch({
      type: Act.SNA_APPLY_FETCH_DATASET,
      payload: true,
    });
  };

  return (
    <Box my={4}>
      <ButtonMain
        buttonProps={{
          text: intl.formatMessage({
            id: "sna.sidebar.filetool.bottompanel.generate.sna.graph",
            defaultMessage: "產生網絡圖",
          }),
          fullWidth: true,
          onClick: handleSubmit,
          disabled: disabledSubmitBtn,
          variant: disabledSubmitBtn ? "disabled" : null,
          sx: { ...getSubmitBtnSx() },
        }}
      />
    </Box>
  );
};

export default BottomPanel;
